const content: { [key: string]: string } = {
  message: "You are currently logged in through ABO impersonation. Please don't modify any user-specific settings.",
  aboLabel: "ABO",
  affLabel: "Aff",
};

export default content;
